import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SweetAlert from 'sweetalert-react';

import { APIHandler, AttendeeForm, StorageHandler } from 'config/C4';
import { storageKeys } from 'config/settings';

export default class MeetingOptInView extends Component {
  constructor() {
    super();
    this.state = {
      meetings: [],
      loading: true,
      showAttendeeForm: false,
      accessToken: '',
      showThankYouPopup: false,
    };

    this.handleMeetingOptIn = this.handleMeetingOptIn.bind(this);
    this.meetingOptIn = this.meetingOptIn.bind(this);
    this.closeThankYouPopup = this.closeThankYouPopup.bind(this);
    this.handleSavePreferences = this.handleSavePreferences.bind(this);
  }

  async componentDidMount() {
    // Check if access token exists, if not show AttendeeForm
    const accessToken = await StorageHandler.load(storageKeys.accessToken);
    
    // Set all meeting opt-ins to selected by default
    const allMeetingIds = [1851, 1853, 1854, 1855]; // family, luxury, adventure, romance
      this.setState({
      showAttendeeForm: !accessToken, 
      accessToken,
      meetings: allMeetingIds,
      loading: false,
    });
    
    // Process meeting opt-ins immediately if we have a token (but don't show popup on initial load)
    if (accessToken) {
      this.meetingOptIn(accessToken, false);
    }
  }

  handleMeetingOptIn(appId) {
    const { meetings, accessToken } = this.state;
    const meetingsArray = [...meetings];

    if (meetingsArray.includes(appId)) {
      const index = meetingsArray.indexOf(appId);
      if (index > -1) {
        meetingsArray.splice(index, 1);
      }
    } else {
      meetingsArray.push(appId);
    }
    
    this.setState({ meetings: meetingsArray }, () => {
      // After state update, save preferences if user is logged in
      if (accessToken) {
        this.meetingOptIn(accessToken, true);
      }
    });
  }

  async meetingOptIn(token, showPopup = false) {
    const { meetings } = this.state;
    const tokenToUse = token || this.state.accessToken;

    if (meetings && meetings.length > 0) {
      if (tokenToUse) {
        // If we have an accessToken, make the API calls immediately
        // Wait for all API calls to complete before showing popup
        const apiPromises = meetings.map((appId) => 
          APIHandler.addMeetingRequest(appId, tokenToUse)
        );
        
        try {
          await Promise.all(apiPromises);
          // Show thank you popup after all API calls succeed (only if showPopup is true)
          if (showPopup) {
            this.setState({ showThankYouPopup: true });
          }
        } catch (error) {
          console.error('Error saving meeting preferences:', error);
        }
      } else {
        // Store meetings opt-in for later processing when user logs in
        StorageHandler.save(storageKeys.meetingsOptIn, meetings);
      }
    }
  }

  closeThankYouPopup() {
    this.setState({ showThankYouPopup: false });
  }

  handleSavePreferences() {
    const { accessToken } = this.state;
    if (accessToken) {
      // Use the same logic as when checkboxes are changed - save and show popup
      this.meetingOptIn(accessToken, true);
    }
  }

  handleAfterLogin = (token) => {
    console.log('handleAfterLogin called with token:', token);
    // Save access token to storage
    if (token) {
      StorageHandler.save(storageKeys.accessToken, token);
    }
    
    // Update access token in state and hide the form
    this.setState({ 
      accessToken: token,
      showAttendeeForm: false,
    });
    
    // Process meeting opt-ins with the new token and show popup after login
    if (token) {
      this.meetingOptIn(token, true);
    }
  }

  handleOpenPopup = (registerObject, token) => {
    // After registration, update access token and process meetings
    console.log('handleOpenPopup called', { registerObject, token });
    this.handleAfterLogin(token);
  }



  render() {
    const {
      meetings,
      loading,
      showAttendeeForm,
      showThankYouPopup,
      accessToken,
    } = this.state;

    console.log('State:', { meetings, loading, showAttendeeForm });
    return (
      <div className="meetingOptInView">
        <div className="meetingOptInView__content">
          {loading && (
            <div className="loading">
              <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
            </div>
          )}
          {!loading && (
            <React.Fragment>
              <div className="meetingOptInView__content--logo">
                <h1>{'Meeting Opt-In Preferences'}</h1>
              </div>
              <div className="meetingOptInView__content--intro">
                <p>
                  {
                  `Want to connect one-on-one during the Virtual Travel Xpo? Opt in to receive meeting requests from destinations, hotels, and tour operators who are excited to collaborate with you.
                  By opting in, you’ll be visible as “open to meetings” and can accept or decline requests based on your availability and interests. No pressure—just meaningful conversations, on your terms.`
                  }
                </p>
              </div>
              <div className="meetingOptInView__content--checkboxes">
                <div className="checkboxes__item">
                  <label htmlFor="meetingOptIn-family" className="meeting-optin">
                    <input
                        type="checkbox"
                      id="meetingOptIn-family"
                      checked={meetings.includes(1851)}
                      onChange={() => this.handleMeetingOptIn(1851)}
                      />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Family Travel Xpo'}</strong> <br />
                      {'Open for meeting requests'}
                    </span>
                  </label>
                </div>
                <div className="checkboxes__item">
                  <label htmlFor="meetingOptIn-luxury" className="meeting-optin">
                    <input
                        type="checkbox"
                      id="meetingOptIn-luxury"
                      checked={meetings.includes(1853)}
                      onChange={() => this.handleMeetingOptIn(1853)}
                      />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Luxury Travel Xpo'}</strong> <br />
                      {'Open for meeting requests'}
                    </span>
                  </label>
                </div>
                <div className="checkboxes__item">
                  <label htmlFor="meetingOptIn-adventure" className="meeting-optin">
                    <input
                        type="checkbox"
                      id="meetingOptIn-adventure"
                      checked={meetings.includes(1854)}
                      onChange={() => this.handleMeetingOptIn(1854)}
                      />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Adventure Travel Xpo'}</strong> <br />
                      {'Open for meeting requests'}
                    </span>
                  </label>
                </div>
                <div className="checkboxes__item">
                  <label htmlFor="meetingOptIn-romance" className="meeting-optin">
                    <input
                        type="checkbox"
                      id="meetingOptIn-romance"
                      checked={meetings.includes(1855)}
                      onChange={() => this.handleMeetingOptIn(1855)}
                      />
                    <div className="custom-check">
                      <FontAwesomeIcon icon={['fas', 'check']} />
                    </div>
                    <span>
                      <strong>{'Romance Travel Xpo'}</strong> <br />
                      {'Open for meeting requests'}
                    </span>
                  </label>
                </div>
              </div>
              {showAttendeeForm ? (
                <div className="meetingOptInView__form">
                  <AttendeeForm
                    shows={[]}
                    meetings={meetings}
                    openPopup={this.handleOpenPopup}
                    loginUser={this.handleAfterLogin}
                  />
                </div>
              ): (
                <button
                  type="button"
                  className="meetingOptInView__saveButton"
                  onClick={this.handleSavePreferences}
                  disabled={meetings.length === 0}
                >
                  {'Save Meeting Preferences'}
                </button>
            )}
            </React.Fragment>
          )}
        </div>
        <SweetAlert
          title="Thank You!"
          show={showThankYouPopup}
          text="Thank you for setting your meeting preferences - you're all set!"
          type="success"
          showConfirmButton
          confirmButtonText="OK"
          onConfirm={this.closeThankYouPopup}
          onEscapeKey={this.closeThankYouPopup}
          onOutsideClick={this.closeThankYouPopup}
        />
      </div>
    );
  }
}
